// Difficulty knobs that can be applied by Level configs.
// No gameplay wiring in this step; it is a pure data contract.

export type DifficultyTuning = {
  /**
   * Multiplier applied to base snake speed (1.0 = unchanged).
   * Suggested range: 0.8 - 2.0
   */
  snakeSpeedMul: number;

  /**
   * How often food attempts to spawn (lower = more food pressure).
   * Suggested range: 250 - 1200 ms
   */
  foodSpawnEveryMs: number;

  /**
   * Max concurrent foods on the board (pressure + decision density).
   */
  maxFoodOnBoard: number;

  /**
   * Baseline enemy pressure. 0 = no enemies.
   * Later steps will interpret this into spawns/min/max, etc.
   */
  enemyPressure: number;
};

export const Difficulty = {
  easy(): DifficultyTuning {
    return { snakeSpeedMul: 1.0, foodSpawnEveryMs: 900, maxFoodOnBoard: 2, enemyPressure: 0 };
  },
  medium(): DifficultyTuning {
    return { snakeSpeedMul: 1.15, foodSpawnEveryMs: 700, maxFoodOnBoard: 3, enemyPressure: 0.25 };
  },
  hard(): DifficultyTuning {
    return { snakeSpeedMul: 1.35, foodSpawnEveryMs: 550, maxFoodOnBoard: 4, enemyPressure: 0.6 };
  },
  insane(): DifficultyTuning {
    return { snakeSpeedMul: 1.6, foodSpawnEveryMs: 450, maxFoodOnBoard: 5, enemyPressure: 1.0 };
  },
} as const;
